import { Box, Link, Paper, Typography, makeStyles } from '@material-ui/core';
import * as React from 'react';

import DotSeparator from '../../../../components/DotSeparator';
import { District, DistrictListing } from '../../../../services/APIService';
import { formatAddress } from '../../../../services/formatAddress';

interface DistrictGeneralProps {
  district: DistrictListing & Partial<District>;
}

const useStyles = makeStyles((theme) => ({
  districtGen: {
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-evenly'
  }
}));

const DistrictGeneral: React.FC<DistrictGeneralProps> = ({ district }) => {
  const classes = useStyles();

  if (!district.name && !district.districtId) {
    return (
      <Paper className={classes.districtGen}>
        <Typography variant="body2">
          District information not available
        </Typography>
      </Paper>
    );
  }

  const acres =
    district.acreage &&
    `${district.acreage.toLocaleString(undefined, {
      maximumFractionDigits: 0
    })} Acres`;
  const line2 = [district.districtType, acres].filter((v) => v);

  return (
    <Paper className={classes.districtGen}>
      {!!district.county && (
        <Typography variant="body1" gutterBottom>
          {district.county} County
        </Typography>
      )}

      {line2.length > 0 && (
        <Box display="flex" flexDirection="row" flexWrap="wrap">
          {line2.map((text, index) => (
            <React.Fragment key={text}>
              {index > 0 && <DotSeparator color="action" />}
              <Typography variant="body1" noWrap>
                {text}
              </Typography>
            </React.Fragment>
          ))}
        </Box>
      )}

      {!!district.address &&
        formatAddress(district.address).map((addressPart) => (
          <Typography key={addressPart} variant="body2">
            {addressPart}
          </Typography>
        ))}
      {!!district.phone && (
        <Typography variant="body2">{district.phone}</Typography>
      )}
      {district?.website && (
        <Link variant="body2" href={district?.website}>
          {district?.website}
        </Link>
      )}

      <Box mt={2} flex={1} />

      <Typography variant="caption">
        {district.isMember
          ? 'AWBD Member - Data Source: AWBD'
          : 'Not an AWBD Member - Data Source: TCEQ'}
      </Typography>
    </Paper>
  );
};

export default DistrictGeneral;
